import AbstractAPI from '@/services/api/AbstractAPI';

export default class VerificationApi extends AbstractAPI {

  async sendValidationEmail() {
    return this.makeRequest('/verification/send', 'post');
  }

  validateToken(token) {
    return this.makeRequest('/validate', 'post', {token});
  }

  hasValidated() {
    return this.makeRequest('/verification', 'get');
  }
}
